// Pure hulpfuncties: geen state, geen netwerk. Items worden altijd op `id` onderscheiden, nooit op `song_id`
// (hetzelfde lied mag meerdere keren in een setlist staan).

export const idsOf = (items) => items.map((item) => item.id);

export const sameIds = (a, b) => a.length === b.length && a.every((id, index) => id === b[index]);

// Geeft een nieuwe lijst met het item van `from` op positie `to`; ongeldige posities laten de lijst ongewijzigd.
export const moveItem = (items, from, to) => {
  if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) return items;
  const next = items.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next.map((item, index) => ({ ...item, order: index + 1 }));
};

export const countBySong = (items) => items.reduce((counts, item) => {
  if (item.song_id) counts[item.song_id] = (counts[item.song_id] || 0) + 1;
  return counts;
}, {});
